import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c0f8dbf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "edit-goal-list"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "userInfo"
};
const _hoisted_5 = {
  class: "icon"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time_status"
}, "编辑后", -1));
const _hoisted_8 = {
  class: "cont"
};
const _hoisted_9 = {
  class: "top"
};
const _hoisted_10 = /*#__PURE__*/_createTextVNode("解锁目标");
const _hoisted_11 = {
  class: "conditions"
};
const _hoisted_12 = {
  class: "giveaway_type"
};
const _hoisted_13 = {
  class: "prizes"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "info"
};
const _hoisted_17 = {
  class: "num"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time_status"
}, "编辑前", -1));
const _hoisted_19 = {
  class: "cont"
};
const _hoisted_20 = {
  class: "top"
};
const _hoisted_21 = /*#__PURE__*/_createTextVNode("解锁目标");
const _hoisted_22 = {
  class: "conditions"
};
const _hoisted_23 = {
  class: "giveaway_type"
};
const _hoisted_24 = {
  class: "prizes"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "info"
};
const _hoisted_28 = {
  class: "num"
};
const _hoisted_29 = {
  class: "edit_time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
    modelValue: $data.refreshing,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.refreshing = $event),
    onRefresh: $options.onRefresh
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      loading: $data.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
      finished: $data.finished,
      "finished-text": "没有更多了",
      onLoad: $options.getList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.edit_list, (item, index) => {
        var _item$after_val, _item$after_val2, _item$after_val3, _item$before_val, _item$before_val2, _item$before_val3;
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item"
        }, [index == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [_createElementVNode("li", null, _toDisplayString($data.edit_time) + " 共编辑了" + _toDisplayString($data.edit_count) + "次", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: `${_ctx.$imgUrlFilter(item.icon || '', 60)}`
        }, null, 8, _hoisted_6)]), _createElementVNode("p", null, _toDisplayString(item.nickname), 1)]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, "¥" + _toDisplayString($options.formatAmount((_item$after_val = item.after_val) === null || _item$after_val === void 0 ? void 0 : _item$after_val.amount)), 1)]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$after_val2 = item.after_val) === null || _item$after_val2 === void 0 ? void 0 : _item$after_val2.conditions, (condition, index) => {
          return _openBlock(), _createElementBlock("p", {
            key: index
          }, _toDisplayString(index + 1) + ". " + _toDisplayString(condition), 1);
        }), 128))]), _createElementVNode("p", _hoisted_12, _toDisplayString($options.giveawayTypeText), 1), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$after_val3 = item.after_val) === null || _item$after_val3 === void 0 ? void 0 : _item$after_val3.prizes, (prize, pindex) => {
          return _openBlock(), _createElementBlock("div", {
            key: pindex,
            class: "prize_item"
          }, [_createElementVNode("div", {
            class: "cover",
            onClick: _withModifiers($event => {
              var _item$after_val4;
              return $options.showBigImg(pindex, (_item$after_val4 = item.after_val) === null || _item$after_val4 === void 0 ? void 0 : _item$after_val4.prizes);
            }, ["stop"])
          }, [_createElementVNode("img", {
            src: `${_ctx.$imgUrlFilter(prize.img || '', 104)}`
          }, null, 8, _hoisted_15)], 8, _hoisted_14), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(prize.title), 1), _createElementVNode("p", _hoisted_17, "×" + _toDisplayString(prize.num), 1)])]);
        }), 128))])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, "¥" + _toDisplayString($options.formatAmount((_item$before_val = item.before_val) === null || _item$before_val === void 0 ? void 0 : _item$before_val.amount)), 1)]), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$before_val2 = item.before_val) === null || _item$before_val2 === void 0 ? void 0 : _item$before_val2.conditions, (condition, index) => {
          return _openBlock(), _createElementBlock("p", {
            key: index
          }, _toDisplayString(index + 1) + ". " + _toDisplayString(condition), 1);
        }), 128))]), _createElementVNode("p", _hoisted_23, _toDisplayString($options.giveawayTypeText), 1), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$before_val3 = item.before_val) === null || _item$before_val3 === void 0 ? void 0 : _item$before_val3.prizes, (prize, pindex) => {
          return _openBlock(), _createElementBlock("div", {
            key: pindex,
            class: "prize_item"
          }, [_createElementVNode("div", {
            class: "cover",
            onClick: _withModifiers($event => {
              var _item$before_val4;
              return $options.showBigImg(pindex, (_item$before_val4 = item.before_val) === null || _item$before_val4 === void 0 ? void 0 : _item$before_val4.prizes);
            }, ["stop"])
          }, [_createElementVNode("img", {
            src: `${_ctx.$imgUrlFilter(prize.img || '', 104)}`
          }, null, 8, _hoisted_26)], 8, _hoisted_25), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", null, _toDisplayString(prize.title), 1), _createElementVNode("p", _hoisted_28, "×" + _toDisplayString(prize.num), 1)])]);
        }), 128))])]), _createElementVNode("p", _hoisted_29, _toDisplayString(item.edit_time) + " 编辑了解锁目标", 1)]);
      }), 128))])]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]));
}